import { liveUsersDirectoryClient } from "./usersDirectory.live";
import type { UsersDirectoryClient } from "./usersDirectory.types";

/**
 * The users list reads each row's status and last sign-in from the server (SERV-3548), in every
 * build: a development stand-in would show an invented status next to real people.
 */
export const usersDirectoryClient: UsersDirectoryClient = liveUsersDirectoryClient;
